import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-280234f5"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "ListItem"
};
var _hoisted_2 = {
  class: "flex align-center"
};
var _hoisted_3 = {
  class: "item-total"
};
var _hoisted_4 = {
  class: "item-money ml-2"
};
var _hoisted_5 = {
  class: "item-store"
};
var _hoisted_6 = {
  class: "item-time mt-2"
};
var _hoisted_7 = {
  class: "mt-2 flex align-center"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "item-label"
  }, "车牌号:", -1);
});
var _hoisted_9 = {
  class: "item-value"
};
var _hoisted_10 = {
  class: "ml-2"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "item-label"
  }, "方式:", -1);
});
var _hoisted_12 = {
  class: "item-value"
};
var _hoisted_13 = {
  class: "mt-2"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "item-label"
  }, "支付方:", -1);
});
var _hoisted_15 = {
  class: "item-value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.item.weight) + "吨", 1), _createElementVNode("span", _hoisted_4, "￥" + _toDisplayString(_ctx.item.pay), 1)]), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.item.stone), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.item.date), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.item.carNumber), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.item.payType), 1)])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.item.customer), 1)])]);
}